/**
 * Linear bonding curve helpers for Penguin Pad on Robinhood Chain.
 * Frozen formula: price(supply) = basePrice + increment * supply
 */

export function priceAtSupply(basePrice: number, increment: number, supply: number): number {
  return basePrice + increment * Math.max(0, supply)
}

/** Cost in USD to buy `tokens` starting from `supply`. */
export function costForTokens(basePrice: number, increment: number, supply: number, tokens: number): number {
  if (tokens <= 0)
    return 0
  const n = tokens
  const s = Math.max(0, supply)
  return n * basePrice + increment * (n * s + (n * (n - 1)) / 2)
}

/** Approximate number of tokens received for spending `usd` starting from `supply`. */
export function tokensForCost(basePrice: number, increment: number, supply: number, usd: number): number {
  if (usd <= 0)
    return 0
  const s = Math.max(0, supply)
  const a = increment / 2
  const b = basePrice + increment * s - increment / 2
  const c = -usd

  if (Math.abs(a) < 1e-12)
    return b !== 0 ? usd / b : 0

  const discriminant = b * b - 4 * a * c
  if (discriminant < 0)
    return 0

  const n = (-b + Math.sqrt(discriminant)) / (2 * a)
  return Math.max(0, n)
}

/** USD proceeds for selling `tokens` back into the curve, moving supply down from `supply`. */
export function proceedsForTokens(basePrice: number, increment: number, supply: number, tokens: number): number {
  const s = Math.max(0, supply)
  const n = Math.min(Math.max(0, tokens), s)
  if (n <= 0)
    return 0
  return costForTokens(basePrice, increment, s - n, n)
}
